import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleHero from "./components/ArticleHero";
import ArticleContent from "./components/ArticleContent";
import RelatedFinds from "./components/RelatedFinds";
import ArticleCTA from "./components/ArticleCTA";

const blogPostingSchema = {
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "headline": "Complete Pandabuy Spreadsheet Buying Guide for 2026",
  "description": "Learn how to navigate the Pandabuy Spreadsheet database like a pro. From finding the best sneaker deals to verifying seller quality ratings, this comprehensive guide covers every step of the spreadsheet shopping experience.",
  "author": { "@type": "Organization", "name": "Pandabuy Spreadsheet" },
  "datePublished": "2026-06-28",
  "dateModified": "2026-06-29",
  "mainEntityOfPage": { "@type": "WebPage", "@id": "https://pandabuy.run/blog/pandabuy-spreadsheet-buying-guide" },
  "image": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg",
  "publisher": { "@type": "Organization", "name": "Pandabuy Spreadsheet", "logo": { "@type": "ImageObject", "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg" } }
};

export default function PandabuySpreadsheetGuide() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(blogPostingSchema) }}
      />
      <Navbar />
      <main>
        <ArticleHero />
        <ArticleContent />
        <RelatedFinds />
        <ArticleCTA />
      </main>
      <Footer />
    </>
  );
}